module.exports = __webpack_public_path__ + "img/file09.cccdb089.png";